import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xxl-8",
  style: {"margin-top":"-30px"}
}
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7" }
const _hoisted_5 = { class: "symbol symbol-150px symbol-lg-150px symbol-fixed position-relative" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" }, null, -1)
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "d-flex align-items-center mb-2" }
const _hoisted_11 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_12 = { href: "#" }
const _hoisted_13 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_14 = { class: "d-flex flex-wrap fw-bold fs-6 mb-2 pe-2" }
const _hoisted_15 = {
  key: 0,
  class: "d-flex align-items-center me-5"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt me-3" }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt me-3" }, null, -1)
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "list-unstyled" }
const _hoisted_21 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2" }, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2" }, null, -1)
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "d-flex my-4 align-items-center" }
const _hoisted_27 = { class: "me-3" }
const _hoisted_28 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_29 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_30 = { class: "nav-item" }
const _hoisted_31 = { class: "nav-item" }
const _hoisted_32 = { class: "nav-item" }
const _hoisted_33 = { class: "nav-item" }
const _hoisted_34 = { class: "nav-item" }
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = { class: "nav-item" }
const _hoisted_37 = {
  class: "daster",
  style: {"padding":"0 30px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_btnBack = _resolveComponent("btnBack")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_image, {
                class: "w-150px h-150px",
                src: _ctx.evento?.logo,
                fit: 'contain'
              }, null, 8, ["src"]),
              _hoisted_6
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.evento.name), 1),
                  _createElementVNode("a", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen026.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  (_ctx.evento?.place)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        _hoisted_16,
                        _createTextVNode(_toDisplayString(_ctx.evento.place), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.evento?.startdate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("span", {
                          innerHTML: _ctx.dateParticipate(_ctx.evento?.startdate, _ctx.evento?.enddate)
                        }, null, 8, _hoisted_19)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.evento.tipo_name)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                        _createElementVNode("span", null, [
                          _hoisted_22,
                          _createTextVNode(" Evento " + _toDisplayString(_ctx.evento.tipo_name), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.evento.modality)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                        _createElementVNode("span", null, [
                          _hoisted_24,
                          _createTextVNode(" Modalidad " + _toDisplayString(_ctx.evento.modality == 'P' ? 'Presencial' : 'Virtual'), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.evento?.status_name)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                        _createElementVNode("span", {
                          class: _normalizeClass(`badge badge-${_ctx.evento.status_params}`)
                        }, _toDisplayString(_ctx.evento.status_name), 3)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_btnBack, { to: '/events' })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("ul", _hoisted_29, [
            _createElementVNode("li", _hoisted_30, [
              _createVNode(_component_router_link, {
                to: `/events/${_ctx.id}/manager/home`,
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Inicio ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_31, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/events/${_ctx.id}/manager/forms`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Formularios ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_32, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/events/${_ctx.id}/manager/sports`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Deportes ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_33, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/events/${_ctx.id}/manager/clubs`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Instituciones ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_34, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/events/${_ctx.id}/manager/officers`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Oficiales ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_35, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/events/${_ctx.id}/manager/featured`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Destacados ")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_36, [
              _createVNode(_component_router_link, {
                class: "nav-link text-active-primary me-6",
                to: `/events/${_ctx.id}/manager/medals`,
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Medallero ")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loader]
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}